import noop from 'lodash/noop';
import React, { useState } from 'react';
import S from './Filters.styles';
const FilterCheckItem = ({ id, text, name, value, ...otherProps }) => {
    return (React.createElement(S.CheckboxItemContainer, null,
        React.createElement(S.CheckboxItem, { htmlFor: id },
            React.createElement(S.CheckboxInput, { id: id, name: name, value: value, ...otherProps, "aria-lable": value }),
            React.createElement(S.CheckboxText, null,
                text,
                React.createElement(S.Tick, null)))));
};
const Filters = ({ checkboxFilters, categoryValues, topicValues, filters, filterValue, sortByOptions, sortByValue, title, onCheckBoxChange, onFilterChange, onSortChange = noop, }) => {
    const [filterOpen, setFilterOpen] = useState('');
    const selectedAmount = (categoryValues ? categoryValues?.length : 0) +
        (topicValues ? topicValues?.length : 0) +
        (filterValue['year'] === 'all' || filterValue['year'] === undefined ? 0 : 1);
    function updateCheckboxArray(e, key) {
        if (key === 'category' && categoryValues && onCheckBoxChange) {
            const tempValues = categoryValues;
            if (!tempValues.includes(e)) {
                tempValues.push(e);
                onCheckBoxChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== e);
                onCheckBoxChange(key, newList);
            }
        }
        if (key === 'topic' && topicValues && onCheckBoxChange) {
            const tempValues = topicValues;
            if (!tempValues.includes(e)) {
                tempValues.push(e);
                onCheckBoxChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== e);
                onCheckBoxChange(key, newList);
            }
        }
    }
    function allAreNull(arr) {
        return arr.every((element) => element === null);
    }
    return (React.createElement(S.Container, null,
        checkboxFilters && !allAreNull(checkboxFilters) && (React.createElement(S.CheckboxSection, null,
            React.createElement(S.Title, null, title),
            React.createElement(S.CheckboxArea, null, checkboxFilters.map((filter) => filter && (React.createElement(S.CheckboxAreaContainer, { key: filter.title },
                React.createElement(S.CheckboxAreaLabel, { type: "button", active: filterOpen === filter.title, onClick: () => setFilterOpen(filterOpen === filter.title ? '' : filter.title ?? '') },
                    filter.title,
                    React.createElement(S.Chevron, null)),
                React.createElement(S.CheckboxAreaItems, { active: filterOpen === filter.title }, filter.options?.map((item) => (React.createElement(FilterCheckItem, { key: item.id, type: "checkbox", checked: item.name === 'topic'
                        ? topicValues?.includes(item.value ? item.value : null)
                        : categoryValues?.includes(item.value ? item.value : null), id: item.id, name: item.name, value: item.value, text: item.text, onChange: (event) => (setFilterOpen(''),
                        updateCheckboxArray(event.target.value, event.target.name ?? '')) })))))))))),
        filters.map((filter) => (React.createElement(S.CheckboxAreaContainer, { key: filter.key },
            React.createElement(S.CheckboxAreaLabel, { type: "button", active: filterOpen === filter.title, onClick: () => setFilterOpen(filterOpen === filter.title ? '' : filter.title ?? '') },
                filter.title,
                React.createElement(S.Chevron, null)),
            React.createElement(S.CheckboxAreaItems, { active: filterOpen === filter.title },
                React.createElement(FilterCheckItem, { type: "checkbox", checked: filterValue && 'all' === filterValue[filter.key], id: 'all', value: 'all', text: 'All', onChange: () => onFilterChange && (setFilterOpen(''), onFilterChange(filter.key, 'all')) }),
                filter.options?.map((option) => (React.createElement(FilterCheckItem, { key: option.id, type: "checkbox", checked: filterValue && option.value === filterValue[filter.key], id: option.id, value: option.value, text: option.text, onChange: (event) => onFilterChange &&
                        (setFilterOpen(''), onFilterChange(filter.key, event.target.value ?? '')) }))))))),
        sortByOptions && (React.createElement(React.Fragment, null,
            React.createElement(S.SortTitle, null, "Sort By: "),
            React.createElement(S.Filter, null,
                React.createElement(S.FilterDropdown, { id: "sortBy", name: "sortBy", value: sortByValue, onChange: (event) => onSortChange(event.target.value) }, sortByOptions.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.text))))))),
        selectedAmount !== 0 && (React.createElement(S.SelectedButtons, null,
            categoryValues?.map((item) => (React.createElement(S.SelectedBtn, { key: item, type: "button", onClick: () => updateCheckboxArray(item ? item : '', 'category') },
                React.createElement(S.Close, null),
                React.createElement(S.SelectedBtnText, null, item)))),
            topicValues?.map((item) => (React.createElement(S.SelectedBtn, { key: item, type: "button", onClick: () => updateCheckboxArray(item ? item : '', 'topic') },
                React.createElement(S.Close, null),
                React.createElement(S.SelectedBtnText, null, item)))),
            filterValue['year'] !== 'all' && filterValue['year'] !== undefined && (React.createElement(S.SelectedBtn, { type: "button", onClick: () => onFilterChange('year', 'all') },
                React.createElement(S.Close, null),
                React.createElement(S.SelectedBtnText, null, filterValue['year']))),
            React.createElement(S.SelectedBtn, { type: "button", onClick: () => onCheckBoxChange &&
                    (onCheckBoxChange('topic', ['']),
                        onCheckBoxChange('category', ['']),
                        onFilterChange('year', 'all')) },
                React.createElement(S.Close, null),
                React.createElement(S.SelectedBtnText, null, "Clear all"))))));
};
export default Filters;
